// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/LOGO_2-SF.png';
import { FiMenu, FiX } from 'react-icons/fi'; // <-- iconos visibles

function Header() {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Logo CustomSoft Solutions" />
        </Link>
      </div>

      {/* Botón hamburguesa (mobile) */}
      <button
        className="menu-toggle"
        aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
        aria-controls="primary-navigation"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {open ? <FiX /> : <FiMenu />}
      </button>

      <nav
        id="primary-navigation"
        className={`site-navigation ${open ? 'is-open' : ''}`}
        role="navigation"
      >
        <Link to="/" onClick={closeMenu}>Inicio</Link>
        <a href="#servicios-section" onClick={closeMenu}>Servicios</a>
        <a href="#contact-section" onClick={closeMenu}>Contacto</a>
      </nav>
    </header>
  );
}

export default Header;
